export enum UrlEndpoint {
  isMaintenanceDisabled = '/isMaintenanceDisabled',
  lifemapLogsPrefix = `/lifemapLogs/level`,
  authenticate = `/authenticate`,
  participants = `/participants`,
}

export const getUrlWithoutParams = (url: string): string => {
  return decodeURIComponent(url).split('?')[0];
};

export const getUrlParams = (url: string): string | undefined => {
  const urlWithHtmlEncodedAmpersandDecoded: string = url.replaceAll('&amp;', '&');
  return decodeURIComponent(urlWithHtmlEncodedAmpersandDecoded).split('?')[1];
};
